import {ref, watch} from 'vue'
import request from "@/service/request";
import {
    getAddressTree,
    getCityColdColumn,
    getCityColdList,
    getCityHighColumn,
} from "@/service/api";
export let searchType = ref('cold');
export let developer = ref("");
export let checkboxs = ref([]);
export let checkList = ref([]);
export let checkAll = ref(false);
export let tableData = ref([]);

export let total = ref(0)

export let formData = ref({
    quarter: [],
    address: [],
})
export let pagination = ref({
    pageSize: 20,
    pageNum: 1,
})

let column = ref({
    high: [],
    clod: [],
})

watch(pagination, () => {
    getTableData()
}, {immediate: true, deep: true})

let getColumn = async () => {
    let {data: data2} = await request({
        url: getCityColdColumn,
    })
    checkboxs.value = data2
    column.value.clod = data2 || []
}


export async function getTableData() {
    const {address} = formData.value
    let params = {
        ...formData.value,
        ...pagination.value,
        provCode: address[0] ? address[0] : '',
        cityCode: address[1] ? address[1] : '',
        areaCode: address[2] ? address[2] : '',
        selectedColumns: [...checkList.value],

    }
    delete params.address
    let data= await request({
        url: getCityColdList,
        method: 'post',
        data: {
           ...params
        }
    })
    tableData.value =data.rows || []
    total.value = data.total||0
}


export const changeSearchType = () => {
    searchType.value = 'cold';
    checkboxs.value = column.value.clod;
    checkAll.value = false;
    checkList.value = [];
    reset()
}

export const handleCheckAllChange = (flag) => {
    checkList.value = flag ? checkboxs.value.map(item => {
        return item.name;
    }) : [];
}

export const handleCheckItemChange = () => {
    checkAll.value = checkList.value.length === checkboxs.value.length;
}

export const reset = () => {
    formData.value = {
        quarter:[],
        address:[]
    }
    pagination.value = {
        pageSize: 20,
        pageNum: 1,
    }
    // getTableData()
}

export const search = () => {
    getTableData()
}

export let headerInfo = ref({
    provinces:[],
    quarter:[]
})
// 获取省市区地址
const getTree = async () => {
    let {data} = await request({
        url: getAddressTree,
        data: {
            filterateaear: false
        }
    })
    headerInfo.value = {
        provinces:data.provinces||[],
        quarter:data.quarter||[]
    }
    getTableData();
}

export const init = () => {
    getColumn()
    getTree()
}